import BreadCrumb from "../../../../components/BreadCrumb";
import Button from "../../../../components/Button";
import Layout from "../../../../components/Layout";
import { Grid } from "@mui/material";
import { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import useStyles from "../../styles";
import Modal from "../../../../components/Modal";
import { httprequest } from "../../../../data/api";
import { TableSearch } from "../../../../components/Table/TableActions";
import Table from "../../../../components/Table/Table";
import useValidator from "../../../../hooks/useValidator";
import { useParams } from "react-router-dom";
import PageLoader from "../../../../components/PageLoader";
import useWindowSize from "../../../../hooks/useWindow";
// import Badge from "../../../../components/Badge";

const TRANSACTIONBYID = "/api/v1/invoices/student-invoices/transactions/";

const PaymentReview = () => {
  const { id } = useParams();
  const classes = useStyles();
  const width = useWindowSize();
  const mobile = width < 600;
  const [reverseValidator, showReverseValidator] = useValidator();
  const [historyGetting, setHistoryGetting] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [auditTransaction, setAuditTransaction] = useState([]);
  const [searchAuditTransaction, setSearchAuditTransaction] = useState([]);
  const [reverseModal, setReverseModal] = useState(false);
  const [reverseReason, setReverseReason] = useState("");
  const [isReversing, setIsReversing] = useState(false);
  const [loadingDecision, setLoadingDecision] = useState(null);
  const [comment, setComment] = useState({
    comment: ""
  });

  const [activeImage, setActiveImage] = useState(null);
  const imageRefs = useRef([]);

  const handleMouseMove = (e) => {
    if (activeImage === null) return;

    const image = imageRefs.current[activeImage];
    if (!image) return;

    const { left, top, width, height } = e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;

    image.style.transformOrigin = `${x}% ${y}%`;
  };

  const handleMouseLeave = () => {
    setActiveImage(null);
    imageRefs.current.forEach(img => {
      if (img) img.style.transformOrigin = "center center";
    });
  };

  const handleGetHistoryByID = () => {
    setHistoryGetting(true);
    httprequest
      .get(`${TRANSACTIONBYID}${id}`)
      .then((res) => {
        setHistoryGetting(false);
        setHistoryData(res?.data?.data);
        setAuditTransaction(res?.data?.data?.audits || []);
        setSearchAuditTransaction(res?.data?.data?.audits || []);
      })
      .catch((err) => {
        setHistoryGetting(false);
        toast.error(err?.response?.data);
      });
  };

  const handleCommentChange = (e) => {
    const { name, value } = e.target;
    setComment({ ...comment, [name]: value });
  };
    /**
 * Table columns configuration for student invoices
 * @type {Array<Object>} columns
 * @property {string} name - Column header text
 * @property {Function} selector|cell - Cell content renderer
 * @property {boolean} [center] - Center align content
 * @property {boolean} [sortable] - Enable/disable sorting
 */
  const auditColumns = [
    {
      name: "Operated By",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Operated By</p>}
          {`${row?.operated_by?.last_name || "--/--"} ${row?.operated_by?.first_name || "--/--"}`}
        </>
      )
    },
    {
      name: "Event",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Event</p>}
          {`${row?.event || "--/--"}`}
        </>
      )
    },
    {
      name: "Comment",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Comment</p>}
          {row?.comment || "--/--"}
        </>
      )
    },
    {
      name: "Created At",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Created At</p>}
          {row?.created_at?.substring(0, 10) || "--/--"}
        </>
      )
    }
  ];

  /**
 * Handles student invoice search functionality
 * @function handleSearchStudentInvoice
 * @param {Object} e - The input change event
 * @description Filters invoices based on multiple search terms across various fields
 */
  const handleSearchAuditTransaction = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = auditTransaction?.filter((data) => valArray?.every(
      (word) => data?.operated_by?.last_name
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                            data?.operated_by?.first_name
                              ?.toLowerCase()
                              .includes(word.toLowerCase()) ||
                            data?.comment
                              ?.toLowerCase()
                              .includes(word.toLowerCase()) ||
                              data?.event
                                ?.toLowerCase()
                                .includes(word.toLowerCase())
    )
    );
    setSearchAuditTransaction(result);
  };

  const handleTransactionDecision = (dec) => {
    setLoadingDecision(dec);

    const payload = {
      decision: dec,
      comment: comment?.comment
    };

    httprequest
      .post(`${TRANSACTIONBYID}${id}/audits`, payload)
      .then((res) => {
        toast.success(res?.data?.message);
        handleGetHistoryByID();
        setLoadingDecision(null);
      })
      .catch((error) => {
        setLoadingDecision(null);
        toast.error(error?.response?.data?.message);
      });
  };

  // Handle reverse modal
  const handleReverseModal = () => {
    setReverseModal(!reverseModal);
  };

  // Handle reverse reason change
  const handleReverseReasonChange = (e) => {
    setReverseReason(e.target.value);
  };

  // Handle reverse transaction
  const handleReverseTransaction = () => {
    if (!reverseReason.trim()) {
      showReverseValidator(true);

      return;
    }

    setIsReversing(true);
    const payload = {
      reason: reverseReason.trim()
    };

    httprequest
      .post(`${TRANSACTIONBYID}${id}/reverse`, payload)
      .then((res) => {
        setIsReversing(false);
        toast.success(res?.data?.message);
        handleReverseModal();
        setReverseReason("");
        handleGetHistoryByID();
        showReverseValidator(false);
      })
      .catch((error) => {
        setIsReversing(false);
        toast.error(error?.response?.data?.message);
        showReverseValidator(false);
      });
  };

  useEffect(() => {
    handleGetHistoryByID();
  }, []);

  const isPending = historyData?.status === "pending";
  const isApproved = historyData?.status === "approved";

  return (
    <Layout children={
      <>
        <div className="breadcrumb-container">
          <div>
            <BreadCrumb
              link_one="/payment/payment-history"
              link_one_name="Payments History"
              active={historyData?.invoice_name || "--/--"}
              description="view more details about this payment transaction"
            />
          </div>
          {(!isPending && historyData?.payment_method !== "Payment link") && (
            <div className="flex gap-10">
              <Button
                variant="danger"
                buttonSize="fluid"
                color="btndefault"
                buttonName="Reverse Transaction"
                onClick={handleReverseModal}
              />
            </div>
          )}
        </div>
        {historyGetting ? <PageLoader /> : (
          <div className="page-content margin-top-30 padding-block-16 padding-bottom-30 ">
            <div className={classes.intro}>
              <h4>
                Transaction Details
              </h4>
              <p className={classes.statusDescription}>
                  Review transaction - Status:
                <span className={`${classes.historyBadge} ${isPending ? classes.statusPending : isApproved ? classes.statusApproved : classes.statusOther}`}>
                  {historyData?.status}
                </span>
              </p>
            </div>

            {/* Transaction Details Grid */}
            <div className="margin-top-16">
              <Grid container spacing={2}>
                <Grid item lg={2} md={3} sm={4} xs={6}>
                  <div className={`${classes.previewsubheader} text-align-left`}>
                    <div>
                      <p>Total Amount</p>
                      <h4>{historyData?.currency || ""} {historyData?.amount?.toLocaleString() || 0}</h4>
                    </div>
                  </div>
                </Grid>
                <Grid item lg={2} md={3} sm={4} xs={6}>
                  <div className={`${classes.previewsubheader} text-align-left`}>
                    <div>
                      <p>Payment Method</p>
                      <h4>{historyData?.payment_method || "--/--"}</h4>
                    </div>
                  </div>
                </Grid>
                <Grid item lg={2} md={2} sm={2} xs={6}>
                  <div className={`${classes.previewsubheader} text-align-left`}>
                    <div>
                      <p>Paid By</p>
                      <h4>{historyData?.payer ? `${historyData.payer.first_name} ${historyData.payer.last_name}` : "--/--"}</h4>
                    </div>
                  </div>
                </Grid>
                <Grid item lg={2} md={2} sm={3} xs={6}>
                  <div className={`${classes.previewsubheader} text-align-left`}>
                    <div>
                      <p>Paid For</p>
                      <h4>{historyData?.student ? `${historyData.student.first_name} ${historyData.student.last_name}` : "--/--"}</h4>
                    </div>
                  </div>
                </Grid>
                <Grid item lg={2} md={2} sm={3} xs={12}>
                  <div className={`${classes.previewsubheader} text-align-left`}>
                    <div>
                      <p>Date Created</p>
                      <h4>{historyData?.created_at?.substring(0, 10) || "--/--"}</h4>
                    </div>
                  </div>
                </Grid>
                <Grid item lg={2} md={2} sm={3} xs={12}>
                  <div className={`${classes.previewsubheader} text-align-left`}>
                    <div>
                      <p>Date Updated</p>
                      <h4>{historyData?.updated_at?.substring(0, 10) || "--/--"}</h4>
                    </div>
                  </div>
                </Grid>
                <Grid item lg={2} md={3} sm={3} xs={12}>
                  <div className={`${classes.previewsubheader} text-align-left`}>
                    <div>
                      <p>Invoice Number</p>
                      <h4>{historyData?.invoice_no || "--/--"}</h4>
                    </div>
                  </div>
                </Grid>
                <Grid item lg={4} md={4} sm={4} xs={12}>
                  <div className={`${classes.previewsubheader} text-align-left`}>
                    <div>
                      <p>Reference</p>
                      <h4>{historyData?.reference || "--/--"}</h4>
                    </div>
                  </div>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <div className={classes.schoolInfo}>
                    <div className={classes.infoRow}>
                      <span className={classes.label}>Amount paid:</span>
                      <span className={classes.value}>{historyData?.invoice?.amount_paid?.toLocaleString() || 0}</span>
                    </div>
                    <div className={classes.infoRow}>
                      <span className={classes.label}>Discount Value:</span>
                      <span className={classes.value}>{historyData?.invoice?.discount_value?.toLocaleString() || 0}</span>
                    </div>
                    <div className={classes.infoRow}>
                      <span className={classes.label}>Outstanding:</span>
                      <span className={classes.value}>{historyData?.invoice?.outstanding?.toLocaleString() || 0}</span>
                    </div>
                  </div>
                </Grid>
                {historyData?.receipts?.length > 0 && (
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <div className={classes.fordesc}><p>Attached Receipts</p></div>
                    <Grid container spacing={2}>
                      {historyData?.receipts?.map((option, i) => (
                        <Grid item lg={2} md={3} sm={4} xs={12} key={i}>
                          <div
                            className={classes.receiptImageContainer}
                            onMouseMove={handleMouseMove}
                            onMouseEnter={() => setActiveImage(i)}
                            onMouseLeave={handleMouseLeave}
                            data-image-index={i}
                          >
                            <img
                              src={option?.file_url}
                              alt={`Receipt ${i + 1}`}
                              className={classes.receiptImage}
                              ref={el => imageRefs.current[i] = el}
                            />
                            <div className={classes.imageZoomOverlay} />
                          </div>
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>
                )}

                {/* Comment Section - Only show for pending transactions */}
                {(isPending || historyData?.status?.toLowerCase() === "reversed") && (
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <label className={classes.quelabel}>Comment <span className="input-required"> *</span></label>
                    <div className={classes.textandimg}>
                      <textarea
                        type="text"
                        placeholder="Enter comment"
                        name="comment"
                        onChange={handleCommentChange}
                      />
                    </div>
                  </Grid>
                )}
              </Grid>
            </div>
            {/* Audit History - Only show for approved transactions */}
            {(isApproved || historyData?.status?.toLowerCase() === "reversed") && historyData?.audits?.length > 0 && (
              <Table data={searchAuditTransaction} columns={auditColumns} subHeader={true} pagination isLoading={historyGetting} subHeaderComponent={
                auditTransaction?.length > 0 && (
                  <TableSearch placeholder="Search here..." searchTableFunc={handleSearchAuditTransaction} />
                )
              }
              />
            )}

            {/* Action Buttons - Only show for pending transactions */}
            {(isPending || historyData?.status?.toLowerCase() === "reversed") && (
              <div className={classes.mainbatchbtn}>
                <div className={classes.batchbtn}>
                  <Grid container spacing={2}>
                    <Grid item lg={3} md={6} sm={6} xs={6}>
                      <Button
                        variant="danger"
                        buttonName="Decline"
                        buttonSize="full"
                        onClick={() => handleTransactionDecision("decline")}
                        isLoading={loadingDecision === "decline"}
                        color="btndefault"
                      />
                    </Grid>
                    <Grid item lg={3} md={6} sm={6} xs={6}>
                      <Button
                        variant="primary"
                        buttonName="Approve"
                        buttonSize="full"
                        onClick={() => handleTransactionDecision("approve")}
                        isLoading={loadingDecision === "approve"}
                        color="btndefault"
                      />
                    </Grid>
                    <Grid item lg={3} md={6} sm={6} xs={6}>
                      <Button
                        variant="primaryoutline"
                        buttonName="Request Info"
                        buttonSize="full"
                        onClick={() => handleTransactionDecision("request info")}
                        isLoading={loadingDecision === "request info"}
                        color="btnfontprimary"
                      />
                    </Grid>
                    <Grid item lg={3} md={6} sm={6} xs={6}>
                      <Button
                        variant="yellowOutline"
                        buttonName="Double Entry"
                        buttonSize="full"
                        onClick={() => handleTransactionDecision("double entry")}
                        isLoading={loadingDecision === "double entry"}
                        color="btnyellow"
                      />
                    </Grid>
                  </Grid>
                </div>
              </div>
            )}
          </div>
        )}
        <Modal
          title="Reverse Transaction (Admin only)"
          subtitle="Are you sure you want to reverse this transaction? This action cannot be undone."
          modalContent={
            <div className="margin-top-16">
              <Grid container spacing={2}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <div className={classes.previewsubheader}>
                    <div>
                      <p>Transaction Details</p>
                      <h4>{historyData?.invoice_no} - ₦{historyData?.amount}</h4>
                      <p>Paid by: {historyData?.payer ? `${historyData.payer.first_name} ${historyData.payer.last_name}` : "--/--"}</p>
                    </div>
                  </div>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <label className={classes.quelabel}>Reason for Reversal <span className="input-required"> *</span></label>
                  <div className={classes.textandimg}>
                    <textarea
                      type="text"
                      placeholder="Enter reason for reversing this transaction"
                      name="reason"
                      onChange={handleReverseReasonChange}
                      rows={4}
                    />
                  </div>
                  {reverseValidator.message("Reason", reverseReason, "required")}
                </Grid>
              </Grid>
            </div>
          }
          modalFooter={
            <>
              <Grid container spacing={2}>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <Button
                    variant="primaryoutline"
                    buttonName="Cancel"
                    buttonSize="full"
                    color="btnfontprimary"
                    onClick={handleReverseModal}
                    disabled={isReversing}
                  />
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <Button
                    variant="danger"
                    buttonName="Reverse This Transaction"
                    buttonSize="full"
                    onClick={handleReverseTransaction}
                    isLoading={isReversing}
                    color="btndefault"
                  />
                </Grid>
              </Grid>
            </>
          }
          isopen={reverseModal}
          closeModal={handleReverseModal}
        />
        {/* <ToastContainer /> */}
      </>
    }
    />
  );
};

export default PaymentReview;
